import React, {useMemo} from "react";
import {useOrderStatuses} from "../hooks/useOrderStatuses";
import {textColorMap} from "../service/colorService";

type OrderStatusSpanProps = {
    status: string;
};

const OrderStatusSpan: React.FC<OrderStatusSpanProps> = ({status}) => {
    const {statuses} = useOrderStatuses();

    const color = useMemo(() => {
        return statuses.find((s) => s.name === status)?.color ?? "black";
    }, [statuses, status]);

    return (
        <span className={textColorMap[color]}>
            {status}
        </span>
    );
};

export default OrderStatusSpan;